import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapCreditReviewDataFromServer } from "mappers";
import { allMerchantService } from "services";
import { uiActions } from "store";
import { ErrorResponse, CreditReview } from "types";

type ServerData = {
	items: { [key: string]: any }[];
	count: number;
};

type MappedData = {
	items: CreditReview[];
	count: number;
};

const useGetCreditReviewAllMerchantMethodQuery = ({
	tab,
	fetchData,
}: {
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
	tab: string;
}) => {
	const dispatch = useDispatch();
	const { page, sortBy, filters } = fetchData;
	const queryResult = useQuery(
		["getCreditReviewAllMerchantMethod", tab, page, filters, sortBy],
		() =>
			allMerchantService.getAllMerchant({
				page,
				sortBy,
				filters,
			}),
		{
			select: ({ items, count }: ServerData): MappedData => ({
				items: items?.map(mapCreditReviewDataFromServer),
				count,
			}),
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetCreditReviewAllMerchantMethodQuery;
